export var contactSectionContent = {
    title: 'Our pack has your back',
    subheading: 'Like your pup, we’re here when you need us. Reach out to our Pet Support team 7 days a week. They’ll be at your side all throughout your Nom Nom journey.',
    buttonLabel: 'Contact Us',
    ctaUrl: 'https://support.nomnomnow.com/hc/en-us/requests/new',
    hasExternalLink: true,
};
export var pressInquiriesSectionContent = {
    title: 'Press inquiries',
    subheading: 'We love positive reinforcement. Drop us a line so we can chat about our favorite things: dogs, dog food, and creating the world’s most exciting dog food. ',
    buttonLabel: 'Contact us',
    ctaUrl: 'mailto:press@nomnomnow.com',
};
export var faqContactSectionContent = {
    title: 'Still Have Questions?',
    subheading: 'Our Pet Support team has answers. Or if not, they’ll make sure to get them for you from an expert member of our Squad.',
    ctaUrl: 'https://support.nomnomnow.com/hc/en-us/requests/new',
    buttonLabel: 'Contact Us',
    hasExternalLink: true,
};
